import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '..';
import * as fromCompanyProfile from './company-profile.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');
// const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

// feature slice - company profile
const getCompanyProfileSubState = createSelector(
  getSharedAuditState,
  state => state.companyProfile
);

// company profile slice selectors
const getCompanyProfileSkeletonState = createSelector(
  getCompanyProfileSubState,
  state => state.companyProfileSkeleton
);
const getCompanyProfileAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.companyProfileAudit
);
const getAircraftTypeRatingAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.aircraftTypeRatingAudit
);
const getCompanyAddressAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.companyAddressAudit
);
const getCustomerDutyAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.customerDutyAudit
);
const getDelayTypeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.delayTypeAudit
);
const getDepartmentAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.departmentAudit
);
const getDutyTimeBufferAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.dutyTimeBufferAudit
);
const getExpenseTypeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.expenseTypeAudit
);
const getCrewMemberTypeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.crewMemberTypeAudit
);
const getPaymentTypeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.paymentTypeAudit
);
const getBusinessCategoryAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.businessCategoryAudit
);
const getJobGradeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.jobGradeAudit
);
const getStaffEventTypeAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.staffEventTypeAudit
);
const getStaffGroupAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.staffGroupAudit
);

const getDutyTimeAllowanceAuditState = createSelector(
  getCompanyProfileSubState,
  state => state.dutyTimeAllowanceAudit
);

// companyProfileSkeleton selectors
export const getCompanyProfileSkeletonLoaded = createSelector(
  getCompanyProfileSkeletonState,
  state => state.loaded
);
export const getCompanyProfileSkeletonLoading = createSelector(
  getCompanyProfileSkeletonState,
  state => state.loading
);
// const getCompanyProfileSkeletonError = createSelector(
//   getCompanyProfileSkeletonState,
//   state => state.error
// );
// const getCompanyProfileAuditSkeletons = createSelector(
//   getCompanyProfileSkeletonState,
//   getCompanyProfileSkeletonLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
const getCompanyProfileSkeletonIds = createSelector(
  getCompanyProfileSkeletonState,
  fromCompanyProfile.companyProfileSkeletonSelectors.selectIds
);
export const getCompanyProfileAuditSkeleton = createSelector(
  getCompanyProfileSkeletonState,
  getCompanyProfileSkeletonLoaded,
  getCompanyProfileSkeletonIds,
  (state, isLoaded, ids) => {
    return isLoaded ? state.entities[ids[0]] : null;
  }
);

// company profile
export const getCompanyProfileAuditLoaded = createSelector(
  getCompanyProfileAuditState,
  state => state.loaded
);
export const getCompanyProfileAuditLoading = createSelector(
  getCompanyProfileAuditState,
  state => state.loading
);
export const getCompanyProfileAudits = createSelector(
  getCompanyProfileAuditState,
  fromCompanyProfile.companyProfileAuditSelectors.selectAll
);
// aircraft type rating
export const getAircraftTypeRatingAuditLoaded = createSelector(
  getAircraftTypeRatingAuditState,
  state => state.loaded
);
export const getAircraftTypeRatingAuditLoading = createSelector(
  getAircraftTypeRatingAuditState,
  state => state.loading
);
export const getAircraftTypeRatingAudits = createSelector(
  getAircraftTypeRatingAuditState,
  fromCompanyProfile.aircraftTypeRatingAuditSelectors.selectAll
);
// company address
export const getCompanyAddressAuditLoaded = createSelector(
  getCompanyAddressAuditState,
  state => state.loaded
);
export const getCompanyAddressAuditLoading = createSelector(
  getCompanyAddressAuditState,
  state => state.loading
);
export const getCompanyAddressAudits = createSelector(
  getCompanyAddressAuditState,
  fromCompanyProfile.companyAddressAuditSelectors.selectAll
);
// customer duty
export const getCustomerDutyAuditLoaded = createSelector(
  getCustomerDutyAuditState,
  state => state.loaded
);
export const getCustomerDutyAuditLoading = createSelector(
  getCustomerDutyAuditState,
  state => state.loading
);
export const getCustomerDutyAudits = createSelector(
  getCustomerDutyAuditState,
  fromCompanyProfile.customerDutyAuditSelectors.selectAll
);
// delay type
export const getDelayTypeAuditLoaded = createSelector(
  getDelayTypeAuditState,
  state => state.loaded
);
export const getDelayTypeAuditLoading = createSelector(
  getDelayTypeAuditState,
  state => state.loading
);
export const getDelayTypeAudits = createSelector(
  getDelayTypeAuditState,
  fromCompanyProfile.delayTypeAuditSelectors.selectAll
);
// department
export const getDepartmentAuditLoaded = createSelector(
  getDepartmentAuditState,
  state => state.loaded
);
export const getDepartmentAuditLoading = createSelector(
  getDepartmentAuditState,
  state => state.loading
);
export const getDepartmentAudits = createSelector(
  getDepartmentAuditState,
  fromCompanyProfile.departmentAuditSelectors.selectAll
);
// duty time buffer
export const getDutyTimeBufferAuditLoaded = createSelector(
  getDutyTimeBufferAuditState,
  state => state.loaded
);
export const getDutyTimeBufferAuditLoading = createSelector(
  getDutyTimeBufferAuditState,
  state => state.loading
);
export const getDutyTimeBufferAudits = createSelector(
  getDutyTimeBufferAuditState,
  fromCompanyProfile.dutyTimeBufferAuditSelectors.selectAll
);
// expense types
export const getExpenseTypeAuditLoaded = createSelector(
  getExpenseTypeAuditState,
  state => state.loaded
);
export const getExpenseTypeAuditLoading = createSelector(
  getExpenseTypeAuditState,
  state => state.loading
);
export const getExpenseTypeAudits = createSelector(
  getExpenseTypeAuditState,
  fromCompanyProfile.expenseTypeAuditSelectors.selectAll
);
// crew member type
export const getCrewMemberTypeAuditLoaded = createSelector(
  getCrewMemberTypeAuditState,
  state => state.loaded
);
export const getCrewMemberTypeAuditLoading = createSelector(
  getCrewMemberTypeAuditState,
  state => state.loading
);
export const getCrewMemberTypeAudits = createSelector(
  getCrewMemberTypeAuditState,
  fromCompanyProfile.crewMemberTypeAuditSelectors.selectAll
);
// payment type
export const getPaymentTypeAuditLoaded = createSelector(
  getPaymentTypeAuditState,
  state => state.loaded
);
export const getPaymentTypeAuditLoading = createSelector(
  getPaymentTypeAuditState,
  state => state.loading
);
export const getPaymentTypeAudits = createSelector(
  getPaymentTypeAuditState,
  fromCompanyProfile.paymentTypeAuditSelectors.selectAll
);
// business category
export const getBusinessCategoryAuditLoaded = createSelector(
  getBusinessCategoryAuditState,
  state => state.loaded
);
export const getBusinessCategoryAuditLoading = createSelector(
  getBusinessCategoryAuditState,
  state => state.loading
);
export const getBusinessCategoryAudits = createSelector(
  getBusinessCategoryAuditState,
  fromCompanyProfile.businessCategoryAuditSelectors.selectAll
);
// job grade
export const getJobGradeAuditLoaded = createSelector(getJobGradeAuditState, state => state.loaded);
export const getJobGradeAuditLoading = createSelector(
  getJobGradeAuditState,
  state => state.loading
);
export const getJobGradeAudits = createSelector(
  getJobGradeAuditState,
  fromCompanyProfile.jobGradeAuditSelectors.selectAll
);
// staff event
export const getStaffEventTypeAuditLoaded = createSelector(
  getStaffEventTypeAuditState,
  state => state.loaded
);
export const getStaffEventTypeAuditLoading = createSelector(
  getStaffEventTypeAuditState,
  state => state.loading
);
export const getStaffEventTypeAudits = createSelector(
  getStaffEventTypeAuditState,
  fromCompanyProfile.staffEventTypeAuditSelectors.selectAll
);
// staff group
export const getStaffGroupAuditLoaded = createSelector(
  getStaffGroupAuditState,
  state => state.loaded
);
export const getStaffGroupAuditLoading = createSelector(
  getStaffGroupAuditState,
  state => state.loading
);
export const getStaffGroupAudits = createSelector(
  getStaffGroupAuditState,
  fromCompanyProfile.staffGroupAuditSelectors.selectAll
);

// duty time allowance
export const getDutyTimeAllowanceAuditLoaded = createSelector(
  getDutyTimeAllowanceAuditState,
  state => state.loaded
);
export const getDutyTimeAllowanceAuditLoading = createSelector(
  getDutyTimeAllowanceAuditState,
  state => state.loading
);
export const getDutyTimeAllowanceAudits = createSelector(
  getDutyTimeAllowanceAuditState,
  fromCompanyProfile.dutyTimeAllowanceAuditSelectors.selectAll
);
